import { RefObject, useEffect } from 'react';

import { applyClubColor, removeClubColor } from '../utils/clubColors';

export function useClubColors(themeColor?: string | null, ref?: RefObject<HTMLDivElement | null>) {
  useEffect(() => {
    if (!themeColor) {
      removeClubColor(ref?.current ?? undefined);
      return;
    }

    if (themeColor) applyClubColor(themeColor, ref?.current ?? undefined);
  }, [themeColor, ref]);
}
